export const LOCALE_COOKIE = "NEXT_LOCALE" as const;

export const SUPPORTED_LOCALES = ["en", "vi", "ar"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const LANGUAGES: ReadonlyArray<{
  locale: Locale;
  label: string;
  flagSrc: string;
}> = [
  { locale: "en", label: "English", flagSrc: "/flag/usa.svg" },
  { locale: "vi", label: "Tiếng Việt", flagSrc: "/flag/vietnam.svg" },
  { locale: "ar", label: "العربية", flagSrc: "/flag/arabic.svg" },
] as const;

export function coerceLocale(input: unknown): Locale {
  if (typeof input !== "string") return "en";
  const normalized = input.trim().toLowerCase();
  if (normalized.startsWith("vi")) return "vi";
  if (normalized.startsWith("ar")) return "ar";
  return "en";
}
